import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    {
      path: "/",
      name: "HomeView",
      component: () => import("../views/HomeView.vue"),
    },

    {
      path: "/contact-page",
      name: "ContactPage",
      component: () => import("../views/ContactPage.vue"),
    },
    {
      path: "/maritechone-technical-module",
      name: "MaritechoneTechnicalModule",
      component: () => import("../views/MaritechoneTechnicalModule.vue"),
    },
    {
      path: "/maritechone-qhse-module",
      name: "MaritechOne QHSE Module",
      component: () => import("../views/MaritechOneQhseModule.vue"),
    },
    {
      path: "/maritechone-commercial-module",
      name: "MaritechOne Commercial Module",
      component: () => import("../views/MaritechOneCommercialModule.vue"),
    },
    {
      path: "/maritech-one-demo-request",
      name: "MaritechOneDemoRequest",
      component: () => import("../views/MaritechOneDemoRequest.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  },
});

export default router;
